import { createSelector } from "@reduxjs/toolkit";

/**
 * @typedef {import("../store/store").StoreApp} StoreApp
 * @typedef {keyof StoreApp['radioInfo']} radioType
 */

export const radioInfoSelector = createSelector(
  /**
   * @param {StoreApp} state
   */
  (state) => state.radioInfo,
  /**
   * @param {StoreApp['radioInfo'][radioType]} radioInfo
   */
  (radioInfo) => radioInfo,
);

export const radioInfoTypeSelector = createSelector(
  radioInfoSelector,
  /**
   * @param {StoreApp} state
   * @param {radioType} type
   */
  (_, type) => type,
  /**
   * @param {StoreApp['radioInfo']} radioInfo
   * @param {radioType} type
   * @returns {StoreApp['radioInfo'][radioType]}
   */
  (radioInfo, type) => radioInfo[type] || {},
);
